import React, { Component } from 'react';
import { withRouter } from 'react-router';
import moment from 'moment';
import { User, DollarSign, File, Link, Calendar } from 'react-feather';
import InlineErrorMessage from '../../../../components/InlineErrorMessage';
import ProductService from '../../../../services/products/productService';
import VoucherService from '../../../../services/vouchers/voucherService';

class EditVoucher extends Component {
    constructor() {
        super();
        this.state = {
            id: '',
            name: '',
            nameErrorMessage: '',
            voucherCode: '',
            voucherCodeErrorMessage: '',
            isPercentage: true,
            value: 0,
            valueErrorMessage: '',
            isCanExpire: true,
            expiryDate: '',
            expiryDateErrorMessage: '',
            isForAllProduct: true,
            productType: '',
            productTypeErrorMessage: '',
            isActive: true,
            isLoading: false,
            productTypes: [],
        };

        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeVoucherCode = this.handleChangeVoucherCode.bind(this);
        this.handleChangeIsPercentage = this.handleChangeIsPercentage.bind(this);
        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.handleChangeIsCanExpire = this.handleChangeIsCanExpire.bind(this);
        this.handleChangeExpiryDate = this.handleChangeExpiryDate.bind(this);
        this.handleChangeIsForAllProduct = this.handleChangeIsForAllProduct.bind(this);
        this.handleChangeProductType = this.handleChangeProductType.bind(this);
        this.handleChangeIsActive = this.handleChangeIsActive.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.syncProductTypes = this.syncProductTypes.bind(this);
        this.syncVoucher = this.syncVoucher.bind(this);
    }

    componentDidMount() {
        this.setState({ id: this.props.match.params.id }, () => {
            this.syncVoucher();
        });
    }

    parseIdLocal(str) {
        const m = str.match(/^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})$/);
        if (!m) alert('Format harus dd-mm-yyyy hh:mm');
        const [, dd, mm, yyyy, HH, MM] = m.map(Number);
        const d = new Date(yyyy, mm - 1, dd, HH, MM); // month index 0-11
        // validasi tanggal (hindari "overflow" 32 jadi bulan berikutnya)
        if (d.getFullYear() !== yyyy || d.getMonth() !== mm - 1 || d.getDate() !== dd) {
            alert('Tanggal tidak valid');
        }
        return d;
    }

    syncVoucher() {
        VoucherService.Get(this.state.id).then(res => {
            this.setState({
                id: res.data.result.id,
                name: res.data.result.name,
                nameErrorMessage: '',
                voucherCode: res.data.result.voucherCode,
                voucherCodeErrorMessage: '',
                isPercentage: res.data.result.isPercentage,
                value: res.data.result.isPercentage ? parseFloat(res.data.result.value) * 100 : res.data.result.value,
                valueErrorMessage: '',
                isCanExpire: res.data.result.isCanExpire,
                expiryDate: res.data.result.isCanExpire ? moment(res.data.result.expiryDate).local().format('DD-MM-yyyy HH:mm') : moment(new Date()).local().format('DD-MM-yyyy HH:mm'),
                expiryDateErrorMessage: '',
                isForAllProduct: res.data.result.isForAllProduct,
                productType: !res.data.result.isForAllProduct ? res.data.result.productType.id : '',
                productTypeErrorMessage: '',
                isActive: res.data.result.isActive,
                isLoading: false,
            }, () => {
                this.syncProductTypes();
            });
        });
    }

    syncProductTypes() {
        ProductService.GetTypes().then(res => {
            this.setState({ productTypes: res.data.result });
        });
    }

    handleChangeName(ev) {
        this.setState({ name: ev.currentTarget.value, nameErrorMessage: '' });
    }

    handleChangeVoucherCode(ev) {
        this.setState({ voucherCode: ev.currentTarget.value, voucherCodeErrorMessage: '' });
    }

    handleChangeIsPercentage() {
        this.setState({
            isPercentage: !this.state.isPercentage,
            value: 0
        });
    }

    handleChangeValue(ev) {
        this.setState({ value: ev.currentTarget.value, valueErrorMessage: '' });
    }

    handleChangeIsCanExpire() {
        this.setState({
            isCanExpire: !this.state.isCanExpire,
        });
    }

    handleChangeExpiryDate(ev) {
        this.setState({ expiryDate: ev.currentTarget.value, expiryDateErrorMessage: '' });
    }

    handleChangeIsForAllProduct() {
        this.setState({
            isForAllProduct: !this.state.isForAllProduct,
        });
    }

    handleChangeProductType(ev) {
        this.setState({ productType: ev.currentTarget.value, productTypeErrorMessage: '' });
    }

    handleChangeIsActive() {
        this.setState({
            isActive: !this.state.isActive,
        });
    }

    handleSubmit(ev) {
        ev.preventDefault();
        var isError = false;
        if (!this.state.name) {
            this.setState({ nameErrorMessage: 'Nama Voucher harus diisi.' });
            isError = true;
        }
        if (!this.state.voucherCode) {
            this.setState({ voucherCodeErrorMessage: 'Kode Voucher harus diisi.' });
            isError = true;
        }
        if (!this.state.value) {
            this.setState({ valueErrorMessage: 'Nilai Diskon harus diisi.' });
            isError = true;
        }
        if (this.state.isPercentage && (this.state.value < 1 || this.state.value > 100)) {
            this.setState({ valueErrorMessage: 'Nilai Diskon harus lebih besar dari 0 atau lebih kecil dari 100.' });
            isError = true;
        }
        if (this.state.isCanExpire && !this.state.expiryDate) {
            this.setState({ expiryDateErrorMessage: 'Tanggal Kadarluasa harus diisi.' });
            isError = true;
        }
        if (!this.state.isForAllProduct && !this.state.productType) {
            this.setState({ productTypeErrorMessage: 'Tipe Produk harus diisi.' });
            isError = true;
        }

        if (!isError) {
            this.setState({ isLoading: true });
            VoucherService.Update(this.state.id, this.state.name, this.state.voucherCode, this.state.isPercentage, this.state.value, this.state.isCanExpire, this.parseIdLocal(this.state.expiryDate), this.state.isForAllProduct, this.state.productType, this.state.isActive).then(res => {
                this.props.history.push('/admin/vouchers')
            }).finally(() => {
                this.setState({ isLoading: false });
            });
        }
    }

    render() {
        return (
            <div className="form-layout is-separate" style={{ maxWidth: '800px' }}>
                <div className="form-outer">
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-body">
                            <div className="form-section">
                                <div className="form-section-inner pb-8">
                                    <h3 className="has-text-centered">Buat Voucher Baru</h3>
                                    <div className="columns is-multiline">

                                        <div className="column is-12">
                                            <div className="field">
                                                <label>Nama Voucher</label>
                                                <div className="control has-icon">
                                                    <input type="text" className="input" placeholder="" onChange={this.handleChangeName} value={this.state.name} />
                                                    <div className="form-icon">
                                                        <User />
                                                    </div>
                                                    <InlineErrorMessage errorMessages={this.state.nameErrorMessage} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="column is-12 mt-4">
                                            <div className="field">
                                                <label>Kode Voucher</label>
                                                <div className="control has-icon">
                                                    <input type="text" className="input" placeholder="" onChange={this.handleChangeVoucherCode} value={this.state.voucherCode} />
                                                    <div className="form-icon">
                                                        <User />
                                                    </div>
                                                    <InlineErrorMessage errorMessages={this.state.voucherCodeErrorMessage} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="column is-12 mt-4">
                                            <div className="field">
                                                <label>Apakah dalam Persentase?</label>
                                                <div className="control">
                                                    <div className="control">
                                                        <label className="form-switch is-primary">
                                                            <input type="checkbox" className="is-switch" checked={this.state.isPercentage} onChange={this.handleChangeIsPercentage} />
                                                            <i></i>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="column is-12">
                                            <div className="field">
                                                <label>Nilai Diskon ({this.state.isPercentage ? "%" : "Rupiah"})</label>
                                                <div className="control has-icon">
                                                    <input type="number" className="input" value={this.state.value} placeholder="" onChange={this.handleChangeValue} />
                                                    <div className="form-icon">
                                                        <DollarSign />
                                                    </div>
                                                    <InlineErrorMessage errorMessages={this.state.valueErrorMessage} />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="column is-12 columns">
                                            <div className="column is-4 mt-4">
                                                <div className="field">
                                                    <label>Ada Tanggal Kadarluasa?</label>
                                                    <div className="control">
                                                        <div className="control">
                                                            <label className="form-switch is-primary">
                                                                <input type="checkbox" className="is-switch" checked={this.state.isCanExpire} onChange={this.handleChangeIsCanExpire} />
                                                                <i></i>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                this.state.isCanExpire &&
                                                <div className="column is-8 mt-4">
                                                    <div className="field">
                                                        <label>Tanggal Kadarluasa (dd-mm-yyyy hh:mm)</label>
                                                        <div className="control has-icon">
                                                            <input type="string" className="input" placeholder="" defaultValue={this.state.expiryDate} onChange={this.handleChangeExpiryDate} />
                                                            <div className="form-icon">
                                                                <Calendar />
                                                            </div>
                                                            <InlineErrorMessage errorMessages={this.state.expiryDateErrorMessage} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div className="column is-4 mt-4">
                                            <div className="field">
                                                <label>Semua Tipe Product?</label>
                                                <div className="control">
                                                    <div className="control">
                                                        <label className="form-switch is-primary">
                                                            <input type="checkbox" className="is-switch" checked={this.state.isForAllProduct} onChange={this.handleChangeIsForAllProduct} />
                                                            <i></i>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {
                                            !this.state.isForAllProduct &&
                                            <div className="column is-8 mt-4">
                                                <div className="field">
                                                    <label>Tipe produk</label>
                                                    <div className="control has-icon">
                                                        <div className="select is-fullwidth">
                                                            <select onChange={this.handleChangeProductType} value={this.state.productType}>
                                                                <option disabled selected value>Pilih tipe produk</option>
                                                                {
                                                                    this.state.productTypes.length > 0 ?
                                                                        this.state.productTypes.map(productType =>
                                                                            <option value={productType.id} key={productType.id}>{productType.name}</option>
                                                                        )
                                                                        :
                                                                        <option value='0'>No Data</option>
                                                                }
                                                            </select>
                                                            <InlineErrorMessage errorMessages={this.state.productTypeErrorMessage} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="column is-12 mt-4">
                                            <div className="field">
                                                <label>Aktif?</label>
                                                <div className="control">
                                                    <div className="control">
                                                        <label className="form-switch is-primary">
                                                            <input type="checkbox" className="is-switch" checked={this.state.isActive} onChange={this.handleChangeIsActive} />
                                                            <i></i>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="form-section-outer mt-5">
                                    <div className="button-wrap">
                                        <button type="submit" className={"button h-button is-primary is-bold is-raised is-fullwidth " + (this.state.isLoading ? 'is-loading' : '')}>Edit Voucher</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default withRouter(EditVoucher);